var map = {
	"./Mark.png": 9645,
	"./Microsoft-Logo.png": 1686,
	"./Microsoft-Logo2.png": 2822,
	"./People.png": 3143,
	"./avatar10_female.png": 1723,
	"./avatar11_male.png": 4247,
	"./avatar12_male.png": 4714,
	"./avatar13_male.png": 9077,
	"./avatar14_female.png": 7183,
	"./avatar15_female.png": 5488,
	"./avatar16_male.png": 190,
	"./avatar17_female.png": 6202,
	"./avatar18_female.png": 2451,
	"./avatar19_female.png": 5156,
	"./avatar1_female.png": 9661,
	"./avatar20_male.png": 5103,
	"./avatar21_male.png": 3724,
	"./avatar22_female.png": 5422,
	"./avatar23_female.png": 285,
	"./avatar24_water_animal.png": 7844,
	"./avatar25_cat.png": 9451,
	"./avatar26_dog.png": 1946,
	"./avatar27_robot.png": 4049,
	"./avatar28_group.png": 9875,
	"./avatar29_seattle.png": 535,
	"./avatar2_female.png": 4708,
	"./avatar3_male.png": 1068,
	"./avatar4_male.png": 4657,
	"./avatar5_male.png": 7382,
	"./avatar6_female.png": 8856,
	"./avatar7_male.png": 848,
	"./avatar8_male.png": 3333,
	"./avatar9_female.png": 6565,
	"./boticon.svg": 932,
	"./car.svg": 8086,
	"./carfrontview.svg": 864,
	"./editpen.png": 9465,
	"./greentick.svg": 2714,
	"./info.svg": 8712,
	"./microsoftImg.svg": 1613,
	"./personal_info.svg": 6675,
	"./privacy-statement.svg": 1696,
	"./reNfSolidColorAvatar.svg": 4030,
	"./success.png": 9701,
	"./warning.svg": 7240,
	"./welcomeguest-desktop.png": 9053,
	"./welcomeguest-mobile.png": 7103,
	"./welcomeguest-tablet.png": 7881,
	"./world-logo.png": 6150,
	"./world-logo.svg": 2840,
	"./world_map.png": 1067,
	"./world_map.svg": 851,
	"./world_map_mobile.png": 8430,
	"./world_map_tab.png": 1087,
	"./world_map_tablet.png": 8816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8476;